<template>
  <div id="footerButton">
    <button @click="click" :disabled="!active" :class="{ active: active }">
      {{ title }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FooterButton',
  props: ['title', 'active'],
  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
#footerButton {
  button {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 68px;
    font-weight: 900;
    font-size: 22px;
    text-align: center;
    color: #727d8c;
    background-color: #e3ecf6;
    &.active {
      color: #ffffff;
      background-color: #1baaf1;
    }
  }
}
</style>
